import { create } from 'zustand'
import {
	type ColorPair,
	generateSingleSubgeoColor
} from '@/features/subgeo/utils/color-utils'
import type { ViewOnlySubGeo } from '../types'

interface GeometryCheckStore {
	selectedGeo: string
	subgeoColorMap: Map<string, ColorPair>
	highlightedSubgeoId: string | null
	setSelectedGeo: (geo: string) => void
	initializeColors: (subgeos: ViewOnlySubGeo[]) => void
	setHighlightedSubgeo: (id: string | null) => void
	reset: () => void
}

export const useGeometryCheckStore = create<GeometryCheckStore>((set) => ({
	selectedGeo: '',
	subgeoColorMap: new Map(),
	highlightedSubgeoId: null,

	setSelectedGeo: (geo) =>
		set({
			selectedGeo: geo,
			subgeoColorMap: new Map(),
			highlightedSubgeoId: null
		}),

	initializeColors: (subgeos) =>
		set((state) => {
			const newColorMap = new Map(state.subgeoColorMap)
			const sortedSubgeos = [...subgeos].sort((a, b) =>
				a.id.localeCompare(b.id)
			)

			for (const subgeo of sortedSubgeos) {
				if (!newColorMap.has(subgeo.id)) {
					const color = generateSingleSubgeoColor(
						subgeo.id,
						newColorMap
					)
					newColorMap.set(subgeo.id, color)
				}
			}

			return { subgeoColorMap: newColorMap }
		}),

	setHighlightedSubgeo: (id) => set({ highlightedSubgeoId: id }),

	reset: () =>
		set({
			selectedGeo: '',
			subgeoColorMap: new Map(),
			highlightedSubgeoId: null
		})
}))
